import { jsx } from "react/jsx-runtime";
import { forwardRef } from "react";
export default forwardRef((props, ref) => jsx("svg", {
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 -0.5 21 21",
    ref,
    ...props,
    dangerouslySetInnerHTML: { __html: '<path d="M4.359 12.292v1.25a2.5 2.5 0 0 0 2.5 2.5h7.083a2.5 2.5 0 0 0 2.5-2.5v-1.25m-6.042-.417V3.958m-2.708 5 2.708 2.917 2.709-2.917" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />' }
  })
);